import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog';
import { cn } from '@/shared/lib/utils';
import { Text } from '../../text';

type AlertDialogDescriptionProps = React.ComponentPropsWithRef<
  typeof AlertDialogPrimitive.Description
>;

export const AlertDialogDescription = ({
  className,
  ref,
  children,
  ...props
}: AlertDialogDescriptionProps) => (
  <AlertDialogPrimitive.Description asChild ref={ref} {...props}>
    <div
      className={cn(
        typeof children !== 'string' && 'text-sm text-text-muted',
        'leading-[22px]',
        className,
      )}
    >
      {typeof children === 'string' ? (
        <Text as="span" color="muted">
          {children}
        </Text>
      ) : (
        children
      )}
    </div>
  </AlertDialogPrimitive.Description>
);
